// src/components/FeatureSection.tsx
import React from 'react';
import './FeatureSection.scss';

const FeatureSection: React.FC = () => {
    return (
        <section className="features">
            <h2 className="features-title">Why Choose Us?</h2>
            <div className="features-container">
                <div className="feature-item">
                    <img src="/path-to-your-recipe-icon.svg" alt="Recipe Creation" />
                    <h3>Recipe Creation</h3>
                    <p>Easily create and save your favorite recipes with detailed instructions and nutritional information.</p>
                </div>
                <div className="feature-item">
                    <img src="/path-to-your-meal-planning-icon.svg" alt="Meal Planning" />
                    <h3>Meal Planning</h3>
                    <p>Plan your meals ahead of time with our intuitive meal planner, making your week stress-free.</p>
                </div>
                <div className="feature-item">
                    <img src="/path-to-your-grocery-list-icon.svg" alt="Grocery List" />
                    <h3>Grocery List</h3>
                    <p>Generate a shopping list based on your meal plan, ensuring you never forget an ingredient.</p>
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
